export const Config = {
 
  // API_BASE_URL: "//localhost:12983/api/v1",
  //API_BASE_URL: "//bidevrpt03.dev.com:8002/api/v1",
  //API_BASE_URL: "//bidevrpt03.dev.com:8004/api/v1", // CRN TST HTTPS
  //API_BASE_URL: "//localhost:12982/api/v1",
  //API_BASE_URL_LOCAL: "//localhost:12982/api/v1",
  //API_BASE_URL: '//afs-dev-ras-api.azurewebsites.net/api/v1/',
  API_BASE_URL: '//afs-prod-crn-api.azurewebsites.net/api/v1/',
  CACHE_ENABLED: false,
};
